var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import styled from "styled-components";
import buttonCss from "./styled";
import Load from "../FormItem/utils/Load";
import Loader from "../Loading/Loader";
import Flex from "../Flex";
import Icon from "../Icon";
var DEFAULT_LOADING = React.createElement(Loader, null);
var MIN_WIDTH_NEEDED_TO_DISPLAY_DEFAULT_LOADER = 39;
var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), buttonCss);
var ChildWrapper = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  ", "\n"])), function (props) { return Button.getChildWrapperDisplayCss(props); });
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonComponent = React.createRef();
        _this.state = {};
        _this.isButtonLargeEnoughForLoader = function () {
            if (_this.buttonComponent.current) {
                var _a = _this.buttonComponent.current.getBoundingClientRect().width, width = _a === void 0 ? 0 : _a;
                return width > MIN_WIDTH_NEEDED_TO_DISPLAY_DEFAULT_LOADER;
            }
            return false;
        };
        _this.isThisButtonLoading = function () {
            var _a = _this.props, apolloState = _a.apolloState, loadRef = _a.loadRef;
            var loaded = _this.state.loaded;
            if (loaded && !apolloState.loading) {
                return false;
            }
            return !(loadRef && loadRef.current !== _this);
        };
        return _this;
    }
    Button.prototype.componentDidMount = function () {
        this.loader = new Load(this);
    };
    Button.prototype.componentWillUnmount = function () {
        if (this.loader)
            this.loader.destroy();
    };
    Button.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.loader)
            this.loader.update({ load: nextProps.load });
    };
    Button.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, apolloState = _a.apolloState, loading = _a.loading, children = _a.children, small = _a.small, large = _a.large, icon = _a.icon, props = __rest(_a, ["disabled", "apolloState", "loading", "children", "small", "large", "icon"]);
        var loaded = this.state.loaded;
        var isThisButtonLoading = this.isThisButtonLoading();
        var isLoading = isThisButtonLoading && (!loaded || apolloState.loading);
        var isDisabled = disabled || (!isThisButtonLoading && !loaded);
        var isLargeEnoughForLoader = this.isButtonLargeEnoughForLoader();
        var isUsingDefaultLoader = Button.isUsingDefaultLoader(loading);
        var isAllowedToDisplayLoading = (isUsingDefaultLoader && isLargeEnoughForLoader) || !isUsingDefaultLoader;
        return (React.createElement(StyledButton, __assign({}, props, { type: "button", small: small, large: large, ref: this.buttonComponent, disabled: isLoading || isDisabled }),
            React.createElement(Flex, { alignItems: "center" },
                isLoading && isAllowedToDisplayLoading && loading,
                React.createElement(ChildWrapper, { isLoading: isLoading, loading: loading, isLargeEnoughForLoader: isLargeEnoughForLoader },
                    icon && React.createElement(Icon, { icon: icon }),
                    children))));
    };
    Button.defaultProps = {
        disabled: false,
        loading: DEFAULT_LOADING,
        apolloState: {}
    };
    Button.isUsingDefaultLoader = function (loading) {
        return loading === DEFAULT_LOADING;
    };
    Button.getChildWrapperDisplayCss = function (_a) {
        var isLoading = _a.isLoading, loading = _a.loading, isLargeEnoughForLoader = _a.isLargeEnoughForLoader;
        if (loading === null)
            return;
        if (Button.isUsingDefaultLoader(loading)) {
            if (!isLargeEnoughForLoader)
                return;
            return "visibility: " + (isLoading ? "hidden" : "inherit") + ";";
        }
        return "display: " + (isLoading ? "none" : "inline-block") + ";";
    };
    return Button;
}(PureComponent));
export default Button;
var templateObject_1, templateObject_2;
